
import { storage } from '../lib/storage';
import { ShippingMethod, Store } from '../types';

export const DEFAULT_SHIPPING_METHODS: ShippingMethod[] = [
  {
    id: 'ship-std',
    name: 'Standard Delivery',
    description: 'Reliable delivery via surface transport.',
    baseCost: 25,
    minSubtotalForFree: 1000,
    estimatedDays: '3-5 Days',
    isActive: true
  },
  {
    id: 'ship-exp',
    name: 'Express Shipping',
    description: 'Air priority delivery for faster tech access.',
    baseCost: 75,
    estimatedDays: '1-2 Days',
    isActive: true
  }
];

export const shippingService = {
  getStoreMethods: (storeId: string): ShippingMethod[] => {
    const store = storage.getStoreConfig(storeId);
    return store.shippingConfig?.methods?.filter(m => m.isActive) || DEFAULT_SHIPPING_METHODS;
  },

  calculateCost: (method: ShippingMethod, subtotal: number): number => {
    if (method.minSubtotalForFree && subtotal >= method.minSubtotalForFree) {
      return 0;
    }
    return method.baseCost;
  },

  updateMethods: (storeId: string, methods: ShippingMethod[]) => {
    const store = storage.getStoreConfig(storeId);
    const updated = { ...store, shippingConfig: { methods } };
    storage.saveStoreConfig(updated);
    return updated;
  }
};
